import { plateLetterFunction } from '@/common/queries/plateLetter/plateLetterQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const plateLetterQueryOptions = () => {
  return queryOptions({
    queryKey: ['plateLetter'],
    queryFn: plateLetterFunction,
  });
};
